
import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { Loader } from '@googlemaps/js-api-loader'
import { Ivg } from '~/types/models/Ivg'

@Component
export default class TheMap extends Vue {
  @Prop() items!: Ivg[]
  public componentLoader: any | null = null
  async mounted() {
    const points = this.items
      .filter(
        (item) =>
          item.location?.coordinates.length > 0 && item.denominazione !== 'NULL'
      )
      .map((item) => {
        return {
          position: {
            lat: item.location.coordinates[1],
            lng: item.location.coordinates[0],
          },
          title: item.denominazione,
          email: item.email,
          telefono: item.telefono,
        }
      })
    await this.initMap(points)
  }

  public async initMap(points: any[] = []) {
    this.componentLoader = await this.mapComponentLoader()
    const google = await this.componentLoader.load()
    const { AdvancedMarkerElement, PinElement } =
      await google.maps.importLibrary('marker')
    const { Map, InfoWindow } = await google.maps.importLibrary('maps')

    const map = new Map(this.$refs.googleMap, {
      center: {
        lat: 42.152636,
        lng: 12.345637,
      },
      zoom: 6,
      mapId: process.env.GOOGLE_MAPS_ID,
    })

    const infoWindow = new InfoWindow()

    for (let i = 0; i < points.length; i++) {
      const pin = new PinElement({
        background: '#0052cc',
        borderColor: '#0061f2',
        glyphColor: 'white',
      })

      const marker = new AdvancedMarkerElement({
        map,
        position: points[i].position,
        title: points[i].title,
        content: pin.element,
      })

      google.maps.event.addListener(marker, 'click', () => {
        infoWindow.close()
        infoWindow.setContent(this.markerHTML(points[i]))
        infoWindow.open(map, marker)
        if (map) {
          map.panTo(marker.position)
        }
      })
    }
  }

  public mapComponentLoader() {
    if (this.componentLoader) {
      return this.componentLoader
    }
    return new Loader({
      apiKey: this.$config.googleMapKey,
      version: 'beta',
      language: 'it',
      libraries: ['marker'],
    })
  }

  public markerHTML(ivg: any) {
    return `<div class="bg-primary text-white px-3 pb-2 pt-3 d-flex flex-column justify-content-between ">
            <p class="mb-auto fs-10 text-uppercase font-weight-bold line-clamp-2">${ivg.title}</p>
            <div class="w-100 pt-2 mt-1">
              <p class="mb-1-5"><b>Email:</b> ${ivg.email}</p>
              <p class="mb-1"><b>Telefono:</b> ${ivg.telefono}</p>
            </div>
          </div>`
  }
}
